import { render, staticRenderFns } from "./chapter-outro.vue?vue&type=template&id=5c6b85c9&scoped=true"
import script from "./chapter-outro.vue?vue&type=script&lang=js"
export * from "./chapter-outro.vue?vue&type=script&lang=js"
import style0 from "./chapter-outro.vue?vue&type=style&index=0&id=5c6b85c9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c6b85c9",
  null
  
)

export default component.exports